/**
 * Docker reports CPU like `docker stats`: 100% = one core, so a container may show 86% while using a ninth of an
 * 8-core server. Shown here as the share of what the container may use, plus the cores actually busy.
 */
export function cpuShare(cpuPercent: number | null | undefined, cores: number | null | undefined): { pct: number; used: string; cores: number | null } | null {
  if (cpuPercent === null || cpuPercent === undefined) return null;
  const c = cores && cores > 0 ? cores : null;
  const pct = c ? Math.min(100, Math.round(cpuPercent / c)) : Math.round(cpuPercent);
  return { pct, used: (cpuPercent / 100).toFixed(cpuPercent < 100 ? 2 : 1), cores: c };
}
